import { StrongText, StyledFlex } from '@dreryk/react-components';

import { StyledText } from './NameCell.styled';

type NameCellProps = {
   name: string;
   additionalDescription?: string;
};

export const NameCell = (props: NameCellProps): JSX.Element => (
   <StyledFlex direction={'column'} gap={'2px'}>
      <StrongText testId={'name'}>{props.name}</StrongText>
      {props.additionalDescription ? (
         <StyledText testId={'additionalDescription'}>{props.additionalDescription}</StyledText>
      ) : null}
   </StyledFlex>
);
